"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _popup = _interopRequireDefault(require("./popup.c"));

var _alertBase = _interopRequireDefault(require("./content/alertBase.c"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Alert =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Alert, _Component);

  function Alert() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Alert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Alert)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleSubmit", function () {
      if (typeof _this.props.onSubmit === 'function') {
        _this.props.onSubmit();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Alert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          root = _this$props.root,
          fx = _this$props.fx,
          closeAvailable = _this$props.closeAvailable,
          minOffsetTop = _this$props.minOffsetTop,
          needTitle = _this$props.needTitle,
          className = _this$props.className,
          children = _this$props.children,
          modalStyle = _this$props.modalStyle,
          style = _this$props.style,
          buttonLabel = _this$props.buttonLabel,
          title = _this$props.title,
          open = _this$props.open;
      return _react["default"].createElement(_popup["default"], {
        root: root,
        fx: fx,
        closeAvailable: closeAvailable,
        minOffsetTop: minOffsetTop,
        style: modalStyle,
        onClose: this._handleSubmit,
        open: open
      }, _react["default"].createElement(_alertBase["default"], {
        needTitle: needTitle,
        buttonLabel: buttonLabel,
        title: title,
        className: className,
        style: style,
        closeAvailable: closeAvailable,
        onSubmit: this._handleSubmit
      }, children));
    }
  }]);
  return Alert;
}(_react.Component);

(0, _defineProperty2["default"])(Alert, "propTypes", {
  root: _propTypes["default"].object,
  fx: _propTypes["default"].object,
  closeAvailable: _propTypes["default"].bool,
  needTitle: _propTypes["default"].bool,
  minOffsetTop: _propTypes["default"].number,
  className: _propTypes["default"].string,
  buttonLabel: _propTypes["default"].string,
  title: _propTypes["default"].string,
  children: _propTypes["default"].any,
  modalStyle: _propTypes["default"].object,
  style: _propTypes["default"].object,
  onSubmit: _propTypes["default"].func,
  open: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.gutter * 45 + 'px'
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 10 + 'px'
     */
    paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 4 + 'px'
     */
    paddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 4 + 'px'
     */
    paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 4 + 'px'
     */
    paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0
     */
    marginTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 3 + 'px'
     */
    marginBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    marginLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    marginRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
});
(0, _defineProperty2["default"])(Alert, "displayName", 'Alert');
var _default = Alert;
exports["default"] = _default;